import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DateStringPipe } from '../../pipe/date-string.pipe';
import { Subject } from 'rxjs';
import { Sgkz011aResponseUserOrganizationDto } from 'sg-api';
import { TimeApiService } from '../../services/time-api.service';
import { UsedSgkz011aService } from '../../services/used-sgkz011a.service';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UsedSgkz012aService } from '../../services/used-sgkz012d.service';

/**
 * サイドメニューコンポーネント
 * @export
 * @class HeaderComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [DateStringPipe]
})
export class HeaderComponent implements OnInit, OnDestroy {

  @Output() sidenavToggle = new EventEmitter();

  /** 画面表示用:業務日付 */
  businessDate: string = '';
  /** 画面表示用:ユーザ名 */
  userName: string = '';
  /** 画面表示用:ユーザ組織情報 */
  userOrganizationInfo: Sgkz011aResponseUserOrganizationDto = {
    sosikiId: '',
    sosikiName: '',
    comgrpcd: '',
    comCode: '',
    topSosikiId: '',
    areaCd: '',
    kyotenHyojiFlg: '',
    cmpnyName: '',
  };

  isKenmu: boolean = false;

  /** 購読停止用Subject */
  private onDestroy$ = new Subject();

  /**
   * コンストラクタ
   * @memberof HeaderComponent
   */
  constructor(private timeApiService: TimeApiService,
    private usedSgkz011aService: UsedSgkz011aService,
    private router: Router,
    private usedSgkz012aService: UsedSgkz012aService) { }

  /**
   * 初期処理
   *
   * @memberof HeaderComponent
   */
  ngOnInit(): void {
    this.usedSgkz011aService.userKanjiname.pipe(takeUntil(this.onDestroy$)).subscribe(userName => {
      this.userName = userName;
    });

    this.usedSgkz011aService.userOrganizationInfo.pipe(takeUntil(this.onDestroy$)).subscribe(userOrganizationInfo => {
      this.userOrganizationInfo = userOrganizationInfo;
    });

    this.timeApiService.bussinessDate.pipe(takeUntil(this.onDestroy$)).subscribe(businessDate => {
      this.businessDate = businessDate;
    });

    this.usedSgkz012aService.soshikiKenmuInfo.pipe(takeUntil(this.onDestroy$)).subscribe(soshikiKenmuInfoList => {
      this.isKenmu = soshikiKenmuInfoList.length > 1;
    });
  }

  /**
   * 終了処理
   *
   * @memberof HeaderComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * サイドメニュー閉じる
   * @memberof HeaderComponent
   */
  public onSidenavClose() {
    this.sidenavToggle.emit();
  }

  /**
   * 要員選択画面へ遷移
   * @memberof HeaderComponent
   */
  onClick(): void {
    this.router.navigate(['/sgkz007d']);
  }
}